var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"elevation":"0","rounded":"0"}},[(_vm.token && _vm.cardType)?_c('MarqetaCreatePIN',{attrs:{"token":_vm.token,"card":_vm.cardType}}):(_vm.invalidCardType)?_c('div',{staticClass:"error--text"},[_vm._v("Invalid card type")]):_c('div',{staticClass:"error--text"},[_vm._v("Missing token or card type query parameter")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }